import { useRef } from "react";
import { AbortError, validationSuccessful } from "sprint-common-web";

import { useAdminEncodeSpecificationApi } from "../../../api/useAdminEncodeSpecificationApi";

export const useFfmpegCommandValidation = () => {
    const { validateFfmpegCommand: validateCommand } = useAdminEncodeSpecificationApi();

    const abortController = useRef<AbortController>(new AbortController());

    const validateFfmpegCommand = async (command: string | undefined) => {
        abortController.current.abort();
        abortController.current = new AbortController();

        if (!command) {
            return validationSuccessful();
        }

        return validateCommand({ command }).catch((error: Error) => {
            if (error instanceof AbortError) {
                return validationSuccessful();
            }

            throw error;
        });
    };

    return {
        validateFfmpegCommand
    };
};
